import React, { Component } from 'react'
import { graphql, compose } from 'react-apollo'
import { withRouter } from 'react-router-dom'

import { Form, TextAreaInput } from '../UI'

import { validateRequired, validateLength } from '../../libs/validation'
import { NotificationManager } from 'react-notifications'

import { translate } from 'react-i18next'

import CREATE_GUIDE_PROFILE_QUERY from './../../graphql/CreateGuideProfile.graphql'
import UPDATE_GUIDE_PROFILE_QUERY from './../../graphql/UpdateGuideProfileAboutMyself.graphql'
import USER_PROFILE_BY_USER_QUERY from './../../graphql/UserByID.graphql'

import Loader from '../UI/Loader'
import get from 'lodash/get'


class DescriptionForm extends Component {
  state = {
    routeIndex: 1,
    saving: false
  }

  handleSubmit = values => {
    this.props.validate(this.state.routeIndex, true)
    this.setState({
      saving: true
    })

    const { guideProfile } = this.props.data.user[0]

    if (guideProfile) {
      this.props
        .updateGuideProfile({
          variables: {
            id: this.props.data.User.guideProfile.id,
            aboutMyself: values.aboutMyself
          }
        })
        .then(() => {
          this.setState({
            saving: false
          })
          this.props.history.push('/activity-guide-profile/location')
        })
        .catch(err => {
          this.setState({
            saving: false
          })
          NotificationManager.error(err.message, 'Error', 5000)
        })
    } else {
      this.props
        .createGuideProfile({
          variables: {
            userId: this.props.data.User.id,
            aboutMyself: values.aboutMyself
          }
        })
        .then(() => {
          this.setState({
            saving: false
          })
          this.props.history.push('/activity-guide-profile/location')
        })
        .catch(err => {
          this.setState({
            saving: false
          })
          NotificationManager.error(err.message, 'Error', 5000)
        })
    }
  }

  render() {
    const { t } = this.props

    if (this.props.data.loading) {
      return <Loader showLoader={true} />
    }

    const aboutMyself = this.props.data.user[0].guideProfile ? this.props.data.user[0].guideProfile.aboutMyself : ''

    const { saving } = this.state

    return (
      <div className="steps-screen__form">
        <div className="steps-screen__form-title">Description</div>
        <Form
          onSubmit={this.handleSubmit}
          submitBtnClassname="btn btn-lg btn-primary btn-danger"
          submitBtnName={t('main:save_continue')}
          submittingToServer={saving}
        >
          <div className="steps-screen__form-input-area">
            <div className="steps-screen__form-subtitle">{t('short_description')}</div>
            <div className="form-input-example">{t('short_description_example')}</div>

            <TextAreaInput
              id="aboutMyself"
              placeholder={t('short_description_placeholder')}
              initialValue={aboutMyself}
              maxChars={600}
              minChars={80}
              validationFuncs={[validateRequired, validateLength]}
              isGroup={false}
            />
          </div>
        </Form>
      </div>
    )
  }
}

export default compose(
  translate('guide'),
  graphql(CREATE_GUIDE_PROFILE_QUERY, {
    name: 'createGuideProfile'
  }),
  graphql(UPDATE_GUIDE_PROFILE_QUERY, {
    name: 'updateGuideProfile'
  }),
  graphql(USER_PROFILE_BY_USER_QUERY, {
    options: props => ({
      variables: {
        id: get(props, 'user.id', '')
      },
      options: {
        fetchPolicy: 'network-only'
      }
    })   
  }),
  withRouter
)(DescriptionForm)



// WEBPACK FOOTER //
// src/components/Guide/DescriptionForm.jsx